import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui";

interface CategoryActivationDialogProps {
  open: boolean;
  action: "activate" | "deactivate";
  name: string;
  processing: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirm prompt for activate / deactivate. Copy is contributor-warm but specific:
 * names the category the user is acting on so a misclick is easy to catch.
 */
export function CategoryActivationDialog({
  open,
  action,
  name,
  processing,
  onConfirm,
  onCancel,
}: CategoryActivationDialogProps) {
  const { t } = useTranslation();
  const isDeactivate = action === "deactivate";

  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isDeactivate ? t("ui.deactivateX", { x: name }) : t("ui.activateX", { x: name })}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {isDeactivate
              ? t("feature.categories.confirmDeactivate", { name })
              : t("feature.categories.confirmActivate", { name })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={processing}>{t("ui.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={processing}>
            {isDeactivate ? t("ui.deactivate") : t("ui.activate")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
